import { render } from "./PublicLink.vue?vue&type=template&id=3d6adba0"
import script from "./PublicLink.vue?vue&type=script&lang=js"
export * from "./PublicLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__